import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { Grid } from '@mlc/web-ui-toolkit';
import { faFilter, faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import * as palette from '@mlc/mlc-palette';
import { searchFilterAction } from '../../../store/actions/search.filter.actions';
import { useSearchResults } from '../../hooks/AppStateHook';
import { FilterElements } from './FilterElements';
import SearchFilterModal, {
	defaultFilterValues,
} from './SearchFilterModal/SearchFilterModal';

import * as Styled from './styled';

interface State {
	shouldDisplayFilters: boolean;
}

interface Props {
	theme: 'dark' | 'light';
}

const initialState: State = {
	shouldDisplayFilters: false,
};

/*
    Putting the button + menu in one component makes it more reusable but for it's proper styling it needs certain parent,
    grandparent, etc. elements to not have position: relative so it can position correctly. There probably is a better way
    to do this
*/
const SearchFilters = (props: Props) => {
	const [state, setState] = useState(initialState);

	const { searchFilters } = useSearchResults();
	const [filters, setFilters] = useState({
		...defaultFilterValues,
		...searchFilters,
	});
	const history = useHistory();
	const dispatch = useDispatch();
	const { filterCount } = useSearchResults();

	function handleFilterToggle() {
		setState(prevState => ({
			...prevState,
			shouldDisplayFilters: !prevState.shouldDisplayFilters,
		}));
		document.getElementById(FilterElements.filtersBtnId)!.focus();
	}

	function handleReset() {
		setFilters({ ...defaultFilterValues } as any);
		dispatch(searchFilterAction(searchFilters.keyword, defaultFilterValues));
	}

	function handleFiltersChange(filters: any) {
		setFilters({ ...filters });
	}

	function handleSearchSubmit(filters: any) {
		handleFilterToggle();
		dispatch(searchFilterAction(searchFilters.keyword, filters));

		if (history.location.pathname !== '/search') {
			history.push('/search');
		}
	}

	const textColour =
		props.theme === 'dark' ? palette.mlcText : palette.mlcWhite;

	return (
		<Styled.FiltersWrapper data-analytics-group="advanced-search-filters">
			<Styled.FiltersButton
				onClick={handleFilterToggle}
				data-id={FilterElements.filtersBtnId}
				id={FilterElements.filtersBtnId}
				className="ignore-react-onclickoutside"
			>
				<Styled.FilterMenuIcon icon={faFilter} size="lg" color={textColour} />
				<Styled.FilterButtonLabel color={textColour}>
					Search filters
				</Styled.FilterButtonLabel>
				<Styled.FilterDropdownPopoutContainer>
					<Styled.FilterDropdownArrow
						icon={faAngleDown}
						size="lg"
						color={textColour}
					/>
					{state.shouldDisplayFilters ? (
						<Styled.ArrowContainer>
							<Styled.PopoutArrow
								boxShadow="mlcShadowStrong"
								border="mlcBorderThin"
								borderColor="mlcMediumGrey"
							/>
						</Styled.ArrowContainer>
					) : null}
				</Styled.FilterDropdownPopoutContainer>
				{filterCount > 0 ? (
					<Styled.FilterButtonCountBackground>
						<Styled.FilterButtonCount data-id={FilterElements.filterCountId}>
							{filterCount}
						</Styled.FilterButtonCount>
					</Styled.FilterButtonCountBackground>
				) : null}
			</Styled.FiltersButton>
			{state.shouldDisplayFilters ? (
				<Styled.FiltersMenuWrapper>
					<Styled.Card>
						<Grid>
							<SearchFilterModal
								initialValues={filters}
								onFiltersUpdate={handleFiltersChange}
								onSearchSubmit={handleSearchSubmit}
								onReset={handleReset}
								handleFilterToggle={handleFilterToggle}
							/>
						</Grid>
					</Styled.Card>
				</Styled.FiltersMenuWrapper>
			) : null}
		</Styled.FiltersWrapper>
	);
};

export default SearchFilters;
